
import { i18nText } from '@/locales';
import Vue from "vue";
import Component from "vue-class-component";
import { VisitsStore } from "@/store/modules/Visits";
import { IVisits, IVisitsListItem } from "@/entity/visits/visit.types";
import { getStudioId } from "@/UI/lib/state";
import dayjs from "dayjs";
import { DateTime, Interval } from "ts-luxon";
import { calendarEventT, MoveVisit } from "@/UI/pages/visitsNew/Lib/visitTypes";
import { DateRec, RecordDataForm, ServiceData } from "@/form/visits/New/Record";
import { showNotificationSimple } from "@/UI/lib/messages";
import { RouterNameEnum } from "@/router/router.types";
import { ICategoryRepo } from "@/entity/category/category.types";
import { ClientCategoryStore } from "@/store/modules/ClientsCategory";
import { Alert, Modal } from "ant-design-vue";
import { AppStateStore } from "@/store/modules/appState";

import { ServiceStore } from "@/store/modules/Services";
import { RecordParams,
    RecordParamsData } from "@/UI/pages/visitsNew/Lib/support";

@Component
export class VisitsGeneralMix extends Vue {
    get visit(): IVisitsListItem | any {
        return VisitsStore.visit;
    }
    get visits(): IVisits | null {
        return VisitsStore.visits;
    }
    get clientCategory(): ICategoryRepo | null {
        return ClientCategoryStore.category;
    }

    get workersInVisits(): IVisitsListItem[] | undefined {
        return VisitsStore.workersInVisits;
    }

    visitId(): number {
        return Number(Vue.router.currentRoute.params["id"]);
    }
    newVisit(): boolean {
        return Number(Vue.router.currentRoute.params["id"]) === 0;
    }
    /*RecordParams(): any | null {
        return Vue.router.currentRoute.params["params"] ? JSON.parse(Vue.router.currentRoute.params["params"]) : null;
    }*/





    VisitsDuration(form: RecordDataForm, visitId?: number, dRec?: DateRec): any {
        /*form['visit_date_time_end']
        form['visit_date_time_start']*/

        let result = false;
        const vStart = DateTime.fromSQL(form["visit_date_time_start"]),
            vEnd = DateTime.fromSQL(form["visit_date_time_end"]);

        const times: any = [];
        this.$store.state["visits"]["workersInVisits"].map((visit: IVisitsListItem) => {
            const start = DateTime.fromSQL(visit["visit_dt"] as string).toLocal(),
                end = DateTime.fromSQL(visit["visit_dt_end"] as string).toLocal();
            if (start.hour === vStart.hour && start.minute === vStart.minute) {
                result = true;
            }
            if (start.hour === vStart.hour && start.minute > vStart.minute) {
                result = true;
            }
            //if (start.hasSame(vStart)) result=true

            if (Number(visit.status_id) === 5) return;
            if (visitId && Number(visitId) !== 0) {
                if (Number(visit["id"]) !== Number(visitId)) {
                    times.push({
                        start: { date: start.toMillis(), hour: start.hour, minute: start.minute, time: start },
                        end: { date: end.toMillis(), hour: end.hour, minute: end.minute, time: end },
                        visitId: visit["id"],
                    });
                }
            } else if (visitId === undefined) {
                times.push({
                    start: { date: start.toMillis(), hour: start.hour, minute: start.minute, time: start },
                    end: { date: end.toMillis(), hour: end.hour, minute: end.minute, time: end },
                    visitId: visit["id"],
                });
            }
        });

        result = false;
        if (dRec) {
            if (times) {
                times.map((tm: any) => {
                    const sT = DateTime.fromMillis(Number(tm.start.date)),
                        eT = DateTime.fromMillis(Number(tm.end.date));
                    const interval = Interval.fromDateTimes(sT, eT);

                    if (
                        interval.contains(DateTime.fromMillis(dRec.start)) ||
                        interval.contains(DateTime.fromMillis(dRec.end))
                    ) {
                        result = true;
                    }
                });
            }
        }
        return { result: result, times: times };
    }

    async updateVisit(value: boolean, form: RecordDataForm, RecordParams: any, noRoute?: boolean): Promise<void> {
        if (value) {
            AppStateStore.setSubmit(false);
            if (!this.newVisit()) {
                //this.form.visit_date = null;
                await VisitsStore.updateNew(form).then(async (response) => {
                    if (response["status"]) {
                        //showNotificationSimple(" Успешное обновление данных визита -", response.response, 10);

                        if (!noRoute)
                            await Vue.router.push({
                                name: RouterNameEnum.VisitsNewStatus,
                                params: {
                                    id: String(response["id"]),
                                },
                            });
                    } else {
                        showNotificationSimple(i18nText(" Ошибка обновления  визита -"), response.response, 2);
                    }
                });
            } else {
                form.new_client = form.client_id === 0;
                await VisitsStore.createNew(form).then(async (response) => {
                    if (response["status"]) {
                        //showNotificationSimple(" Успешное создание визита -", response.response, 10);
                        if (!noRoute)
                            await Vue.router.push({
                                name: RouterNameEnum.VisitsNewStatus,
                                params: {
                                    Studio: getStudioId(this),
                                    Worker: Vue.router.currentRoute.params["Worker"],
                                    params: JSON.stringify(RecordParams()),
                                    id: String(response["id"]),
                                    mode: "status",
                                },
                            });
                    } else {
                        // Убрать условие после починки
                        if (response.response !== 'Время конца визита не может быть раньше времени начала визита') {
                            showNotificationSimple(i18nText(" Ошибка обновления  визита -"), response.response, 2);
                        }
                        // showNotificationSimple(" Ошибка визита -", response.response, 10);
                    }
                });
            }
        }
    }
    async deleteVisit(form: RecordDataForm): Promise<void> {
        let routeDate = new Date().getDate();
        if (form["visit_date"]) routeDate = Date.parse(form["visit_date"]);

        Modal.confirm({
            onOk: (): void => {
                this.$store
                    .dispatch("visits/delete", { id: Number(this.$router.currentRoute.params["id"]) })
                    .then(async (response) => {
                        if (response["status"]) {
                            /* this.$router.push({
                                name: RouterNameEnum.VisitsNewDate,
                                params: { Date: routeDate.toString(), Studio: getStudioId(this) },
                            }); */

                            form.status_id = 5;
                            await this.pushToCalendar(form, RecordParamsData());
                            showNotificationSimple(i18nText(" Отмена записи —"), response.response, 10);
                            Modal.destroyAll();
                        } else {
                            showNotificationSimple(i18nText(" Не удалось отменить запись —"), response.response, 4);
                            Modal.destroyAll();
                        }
                    });
            },

            onCancel: (): void => {
                Modal.destroyAll();
            },

            autoFocusButton: "true",
            content: i18nText("Отменить запись? Визит и история сохранятся, время освободится."),
            okText: i18nText("Отменить запись"),
            cancelText: i18nText("Оставить запись"),
        });
    }



    getCalendarMode(): any {
        if (this.$router.currentRoute.params["Date"] !== undefined) {
            return 1;
        } else {
            return 0;
        }
    }
    getCalendarDayTilte(): string {
        if (this.getCalendarMode() === 0) {
            return i18nText("сегодня");
        } else {
            const date = new Date(Number(this.$router.currentRoute.params["Date"]));
            return dayjs(date.toDateString()).format("DD.MM.YYYY");
        }
    }

    async pushToCalendar(form: RecordDataForm, RecordParams: any): Promise<void> {
        let routeDate = new Date().getDate();

        if (!this.newVisit()) {

            if (form["visit_date"] && form["visit_date"].length>0)
            {
                routeDate = Date.parse(form["visit_date"]);
            }
            else {
                /*debugger
                const date = RecordParamsData().start.split(" ")[0];*/

                routeDate = Date.parse(RecordParamsData().start.split(" ")[0]);

            }
        } else {
            routeDate = Date.parse(RecordParams["date"]);



        }
        await Vue.router.push({
            name: RouterNameEnum.VisitsNewDate,
            params: { Date: routeDate.toString(), Studio: getStudioId(this) },
        });
    }
}
